/**
 * UX Mirror エントリポイント
 * Faro初期化 + React DOM レンダリング
 *
 * @graph-stack ux-mirror
 * @graph-domain UX
 * @graph-business アプリのブートストラップ。Faro RUM初期化・React DOMマウント・CSS/i18n読み込み
 * @graph-connects App [calls] ルートコンポーネント描画
 */

// Faro初期化は他のimportより前に実行
import { initializeFaro } from '@cortex/faro';
initializeFaro({ appName: 'ux-mirror' });

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';
import './i18n';

/** @graph-connects none */
const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
